import { singularize } from 'inflection';
import { toSlug } from '../../utils/string.js';
import * as Conventions from './conventions.js';
import * as Definitions from './definitions.js';
export const isRule = (style) => !!style.type;
export const isOfType = (style, type) => style.type && style.type === type;
export function getClassName(style, styles = []) {
    const slug = getEffectiveSlug(style, styles);
    const definition = Definitions.all.find((d) => d.type == style.type && d.name == style.details.collectionId);
    if ((definition === null || definition === void 0 ? void 0 : definition.isCustom) === false && definition.name != 'media') {
        return `-${slug}`;
    }
    else {
        return `-${style.type}--${slug}`;
    }
}
export function getDefaultClassName(style) {
    return getElementDefinition(style)
        ? '-' + style.details.collectionId
        : getClassName(style).split('--').slice(0, 2).join('--');
}
export function getGenericSelector(style, definitions = Definitions.all) {
    return Conventions.getDefinitionSelectors(getElementDefinition(style, definitions));
}
export function getElementDefinition(style, definitions = Definitions.all) {
    return (definitions.find((d) => d.type == style.type && d.id == style.details.collectionId) ||
        definitions.find((d) => d.type == style.type && d.name == style.type));
}
export function getSelector(style, weight = [0, 0, 0]) {
    switch (style.type) {
        case 'color':
            return ':root';
        case 'font':
            return null;
        default:
            const customization = style.details.instanceId ? `[data-instance-id="${style.details.instanceId}"]` : '';
            const specificity = (weight === null || weight === void 0 ? void 0 : weight.some((w) => w > 0)) ? `:weight(${weight.join('.')})` : '';
            return `.${getClassName(style)}${customization}${specificity}`;
    }
}
export function getCollectionSlug(style) {
    if (style.details.slug) {
        return style.details.slug.split('--')[0];
    }
    return style.details.collectionId;
}
export function getSlugPart(style) {
    const slug = toSlug(style.details.title, true);
    return style.type == 'collection'
        ? (style.props.type in Definitions || style.props.type == 'color' ? '' : style.props.type + '--collection--') +
            singularize(slug)
        : slug;
}
export function getSlug(style, styles) {
    const collection = style.details.collectionId &&
        (style.type == 'text' || style.type == 'block' || style.type == 'inline' || style.type == 'color') &&
        styles.find((s) => s.type == 'collection' && s.details.id == style.details.collectionId);
    if (collection) {
        return getEffectiveSlug(collection, styles) + '--' + getSlugPart(style);
    }
    else {
        return getSlugPart(style);
    }
}
export function getEffectiveSlug(style, styles) {
    // custom rules dont have a slug, they use the id
    if (style.details.elementId) {
        return style.details.id;
    }
    return style.details.slug || getSlug(style, styles);
}
export function findComboInTheme(theme, comboId) {
    if (theme) {
        for (var prop in theme.props) {
            const combo = theme.props[prop].find((c) => c.id === comboId);
            if (combo)
                return combo;
        }
    }
    return null;
}
export function getThemeDefaultComboForType(theme, category) {
    return theme === null || theme === void 0 ? void 0 : theme.props[category].find((c) => c.isDefault);
}
export function matchesSearchQuery(style, query) {
    return style === null || style === void 0 ? void 0 : style.details.title.toLowerCase().includes(query.toLowerCase());
}
//# sourceMappingURL=rule.js.map